import React, { useEffect, useState } from 'react'
import { store } from '../../../redux/store';
import './index.css'
import { Button, Input, Modal, Table, ConfigProvider, notification, Radio, Card, Select, InputNumber } from 'antd';
import { PlusOutlined, DeleteOutlined, MinusOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../generalComponent/search';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
//引入axios 进行服务器接口请求
import axios from "axios";
import { Decimal } from 'decimal.js';
export default function Inventory() {
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
      placement: 'top',
      duration: 1
    });
  };

  const [openMoney, setOpenMoney] = useState(false);
  const [modalMoneyTitle, setModalMoneyTitle] = useState("");
  const [balanceTitle, setBalanceTitle] = useState("");
  const [balanceInfo, setBalanceInfo] = useState();
  const initAloneState = { 'id': '', 'aliPayPrice': '', 'weChatPayPrice': '', 'cashPayPrice': '', 'bankPayPrice': '', 'discountPrice': '', 'balance': '', 'payType': 2 }
  const [aloneState, setAloneState] = useState(initAloneState);//1
  const initialFields = { 'customerId': '', 'mode': '', 'payStatus': '', 'timeSlot': '' };
  const initState = { 'id': '', 'customerId': '', 'payStatus': 2, 'mode': 1, 'payType': 2, 'aliPayPrice': '', 'weChatPayPrice': '', 'cashPayPrice': '', 'bankPayPrice': '', 'discountPrice': '', 'balance': '', 'customerId_isVisible': false, 'mode_isVisible': false, 'payStatus_isVisible': false };
  const [state, setState] = useState(initState);//1
  const [dataSource, setDataSource] = useState([]);
  const [query, setQuery] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [customerList, setCustomerList] = useState([]);//客户信息
  const [packList, setPackList] = useState([]);
  const [packInfo, setPackInfo] = useState(new Map());
  const [goodsList, setGoodsList] = useState({});//1
  const [goodsData, setGoodsData] = useState({});//1
  const [goodsCategoryData, setGoodsCategoryData] = useState({});//商品分类选中值
  const [packSelData, setPackSelData] = useState({});//包装选中值
  const [numSelData, setNumSelData] = useState({});//数量
  const [priceSelData, setPriceSelData] = useState({});//商品价格
  const [totalWeightData, setTotalWeightData] = useState({});//毛重




  const [bulkSale, setBulkSale] = useState([]);//1散装数据
  const [saleDataMap, setSaleDataMap] = useState(new Map());//散装、整装数据map
  const [weightData, setWeightData] = useState({});//1
  const [priceData, setPriceData] = useState({});//包装价格数据
  const [peelData, setPeelData] = useState({});//1
  const [recycleData, setRecycleData] = useState({});//1
  const [averageWeightData, setAverageWeightData] = useState({});//1
  const [totalAmountData, setTotalAmountData] = useState({});//1

  const [wholeSale, setWholeSale] = useState([]);//1

  const [isDivVisible, setIsDivVisible] = useState(false);

  const [goodsCategory, setGoodsCategory] = useState([
    { value: 1, label: '蔬菜' },
    { value: 2, label: '干果' },
    { value: 3, label: '粮油' },
    { value: 4, label: '肉类' },
    { value: 5, label: '海鲜' },
    { value: 6, label: '水产' }
  ]);



  useEffect(() => {
    queryList({});
    queryCustomerList();
    queryPackList();
    //查询客户信息
  }, []); // 空数组确保只在挂载时设置观察者

  //查询客户信息
  function queryCustomerList() {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/custom/list',
      {}, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          const cData = response.data.data;
          let cDataArr = [];
          for (let i = 0; i < cData.length; i++) {
            cDataArr.push(
              { value: cData[i].id, label: cData[i].customerName }
            )
          }
          setCustomerList(cDataArr);
        } else {
          openNotificationWithIcon('error', '消息提示', '客户信息数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //查询包装信息
  function queryPackList() {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/pack/list',
      { status: 1 }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          const pData = response.data.data;
          let pDataArr = [];
          let pInfoDataArr = new Map();
          for (let i = 0; i < pData.length; i++) {
            pDataArr.push(
              { value: pData[i].id, label: pData[i].packName }
            )
            pInfoDataArr.set(pData[i].id, { packWeight: pData[i].packWeight, packPrice: pData[i].packPrice, packUnit: pData[i].packUnit });
          }
          setPackInfo(pInfoDataArr);
          setPackList(pDataArr);
        } else {
          openNotificationWithIcon('error', '消息提示', '包装信息数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  let navigate = useNavigate();

  const token = store.getState().uData.token;
  function queryList(data) {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/order/list',
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data);
          setSelectedRowKeys([])
        } else {
          setDataSource({});
          setSelectedRowKeys([])
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const [open, setOpen] = useState(false);

  //查询数据详情
  function modifyShowModal(id) {
    const params = new URLSearchParams();
    params.append('id', id);
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/order/find',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          setState(response.data.data.stateData);
          setIsDivVisible(response.data.data.stateData.payStatus == 2 ? false : true);
          setGoodsCategoryData(response.data.data.goodsCategoryData);
          setGoodsData(response.data.data.goodsData);
          setPackSelData(response.data.data.packSelData);
          setGoodsList(response.data.data.goodsList);
          setRecycleData(response.data.data.recycleData);
          setPeelData(response.data.data.peelData);
          setPriceData(response.data.data.priceData);
          setWeightData(response.data.data.weightData);
          setTotalAmountData(response.data.data.totalAmountData);

          setNumSelData(response.data.data.numSelData);
          setPriceSelData(response.data.data.priceSelData);
          setTotalWeightData(response.data.data.totalWeightData);
          setAverageWeightData(response.data.data.averageWeightData);

          const newSaleDataMap = new Map(Object.entries(response.data.data.saleDataMap));
          setSaleDataMap(newSaleDataMap);
          setBulkSale(response.data.data.bulkSale);
          setWholeSale(response.data.data.wholeSale);
          console.log("33333333333", response.data.data.bulkSale);
          setModalTitle("编辑订单信息")
          setOpen(true);
        } else {
          openNotificationWithIcon('error', '消息提示', '数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const showModal = () => {
    // setState(initState);
    setBulkSale([]);
    setWholeSale([]);
    setModalTitle("新增订单信息")
    setOpen(true);
  };
  const handleOk = () => {
    handleAddOrModify();
  };
  const handleCancel = () => {
    initData();
    setOpen(false);
  };



  //初始化变量数据
  const initData = () => {
    //清空数据
    setState(initState);
    setGoodsList({});
    setGoodsData({});
    setBulkSale([]);
    setSaleDataMap(new Map());
    setWeightData({});
    setPriceData({});
    setPeelData({});
    setRecycleData({});
    setAverageWeightData({});
    setTotalAmountData({});
    setWholeSale([]);
    setGoodsCategoryData({});
    setPackSelData({});
    setNumSelData({});
    setPriceSelData({});
    setTotalWeightData({});
    setIsDivVisible(false);
  }
  //添加订单
  const addOrder1 = () => {
    alert("11111")
  }

  //清除订单
  const delOrder1 = () => {
    alert("222222")
  }

  //支付
  function paymentMoney(id, balance) {
    setModalMoneyTitle("支付");
    setBalanceInfo(balance);
    setAloneState({
      ...aloneState,
      balance,
      id
    });
    setBalanceTitle("剩余未支付金额:");
    setOpenMoney(true);
  }
  //收款 
  function receiveMoney(id, balance) {
    setModalMoneyTitle("收款")
    setBalanceInfo(balance);
    setAloneState({
      ...aloneState,
      balance,
      id
    });
    setBalanceTitle("剩余未收款金额:");
    setOpenMoney(true)
  }

  const handleOkMoney = () => {
    handleAlonePay();
  };
  const handleCancelMoney = () => {
    //清空数据
    setAloneState(initAloneState);
    setOpenMoney(false);
  };
  function handleAlonePay() {
    let valiad = true;
    //校验
    //  const initState = { 'id': '', 'customerId': '', 'payStatus': 2, 'mode': 1, 'payType': 2, 'aliPayPrice': '', 'weChatPayPrice': '', 'cashPayPrice': '', 'bankPayPrice': '', 'discountPrice': '', 'balance': '', 'customerId_isVisible': false, 'mode_isVisible': false, 'payStatus_isVisible': false };
    const { id, payType, aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice, balance } = aloneState;
    let money = new Decimal(balance);
    if (money.lt(new Decimal('0'))) {
      valiad = false;
      setOpenMoney(true);
      openNotificationWithIcon('warning', '消息提示', "录入的数据不正确,请检查");
    }
    const payJson = {
      payType,
      aliPayPrice,
      weChatPayPrice,
      cashPayPrice,
      bankPayPrice,
      discountPrice,
      balance
    };
    //拼接订单详情数据
    let success_msg = "数据操作成功！";
    let error_msg = "数据操作失败！";

    if (valiad) {
      const data = {
        id,
        "payJson": JSON.stringify(payJson)
      }
      console.log("上送数据:", data);
      //请求后台接口
      axios.post('/api/order/alonePay',
        data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      ).then(
        response => {
          if (response.data.code === "200") {
            setAloneState(initAloneState);
            openNotificationWithIcon('success', '消息提示', success_msg)
            queryList(query);
            setOpenMoney(false);
          } else {
            openNotificationWithIcon('error', '消息提示', error_msg + response.data.msg)
            setOpenMoney(true);
          }

        },
        error => {
          navigate("/error");
        }
      )
    } else {
      setOpenMoney(true);
    }

  }
  //生效和废弃订单
  function handleEffectAndCancel(id, type) {
    if (id === "") {
      openNotificationWithIcon('warning', '消息提示', '请先选择数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('id', id);
    //请求后台接口
    const url = type === 2 ? '/api/order/cancel' : '/api/order/effect';
    const success_msg = type === 2 ? '数据废弃成功！' : '数据生效成功！';
    const error_msg = type === 2 ? '数据废弃失败！' : '数据生效失败！';

    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //操作历史
  function optionHistory(id) {
    navigate("/main/orderhistory?orderId=" + id)
  }


  const limitDecimalPoint = (value) => {
    const reg = /^(-)*(\d+)\.(\d{0,2}).*$/; // 改为2位小数的正则表达式
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '').replace(reg, '$1$2.$3');
  };

  const normalizeDecimalPoint = (value) => {
    if (value && value.toString().indexOf('.') !== -1) {
      return parseFloat(value).toFixed(2); // 保留2位小数并转换为字符串
    }
    return value;
  };
  //添加或者修改
  function handleAddOrModify() {
    //数据入库
    console.log("3---数据集合", saleDataMap);
    console.log("4---数据集合", state);
    let valiad = true;
    //校验
    //  const initState = { 'id': '', 'customerId': '', 'payStatus': 2, 'mode': 1, 'payType': 2, 'aliPayPrice': '', 'weChatPayPrice': '', 'cashPayPrice': '', 'bankPayPrice': '', 'discountPrice': '', 'balance': '', 'customerId_isVisible': false, 'mode_isVisible': false, 'payStatus_isVisible': false };
    const { id, customerId, payStatus, mode, payType, aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice, balance } = state;

    if (!customerId) {
      valiad = false;
      setState(prevState => ({ ...prevState, "customerId_isVisible": true }));
      return;
    }
    if (saleDataMap.size === 0) {
      valiad = false;
      openNotificationWithIcon('success', '消息提示', "请录入订单信息");
      return;
    }
    let orderInfoJson = [];
    const keys = [...saleDataMap.keys()];
    for (let i = 0; i < keys.length; i++) {
      orderInfoJson.push(saleDataMap.get(keys[i]));
    }
    const payJson = {
      payType,
      aliPayPrice,
      weChatPayPrice,
      cashPayPrice,
      bankPayPrice,
      discountPrice,
      balance
    };
    //拼接订单详情数据
    let success_msg = "";
    let error_msg = "";
    if (id) {
      success_msg = "数据修改成功！";
      error_msg = "数据修改失败！";
    } else {
      success_msg = "数据新增成功！";
      error_msg = "数据新增失败！";
    }

    if (valiad) {
      const data = {
        id,
        customerId,
        mode,
        payStatus,
        "orderInfoJson": JSON.stringify(orderInfoJson),
        "payJson": JSON.stringify(payJson)
      }
      console.log("上送数据:", data);
      //请求后台接口
      axios.post('/api/order/addOrModify',
        data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      ).then(
        response => {
          if (response.data.code === "200") {
            initData();
            openNotificationWithIcon('success', '消息提示', success_msg)
            queryList(query);
            setOpen(false);
          } else {
            openNotificationWithIcon('error', '消息提示', error_msg + response.data.msg)
            setOpen(true);
          }

        },
        error => {
          navigate("/error");
        }
      )
    } else {
      setOpen(true);
    }
  }
  //组装Serach组件的查询字段
  const searchFields = [
    {
      fieldName: 'customerId',
      fieldCnName: '客户名称',
      placeholder: '请选择客户名称',
      fieldType: 'select',
      optionData: customerList
    }, {
      fieldName: 'timeSlot',
      fieldCnName: '开单时间',
      placeholder: '请选择开单时间',
      fieldType: 'time'
    }, {
      fieldName: 'mode',
      fieldCnName: '订单类别',
      placeholder: '请选择订单类别',
      fieldType: 'select',
      optionData: [
        { value: 1, label: '销售' },
        { value: 2, label: '采购' }
      ]
    }, {
      fieldName: 'valid',
      fieldCnName: '订单状态',
      placeholder: '请选择订单状态',
      fieldType: 'select',
      optionData: [
        { value: 1, label: '生效' },
        { value: 2, label: '废弃' }
      ]
    }, {
      fieldName: 'payStatus',
      fieldCnName: '支付状态',
      placeholder: '请选择支付状态',
      fieldType: 'select',
      optionData: [
        { value: 1, label: '全支付' },
        { value: 2, label: '赊欠' },
        { value: 3, label: '部分支付' }
      ]
    }
  ]


  const handleSearch = (data) => {

    setQuery(data);
    if (data.timeSlot) {
      data.startTime = data.timeSlot[0]
      data.endTime = data.timeSlot[1]
    }
    delete data.timeSlot
    console.log("查询参数", data);
    //组装查询参数
    queryList(data);
  };

  const payTypeChange = (event) => {
    let balanceMoney = new Decimal(balanceInfo); // 订单总金额
    let payData = {};
    let { aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice } = aloneState;
    switch (event.target.value) {
      case 1: {
        payData.weChatPayPrice = "";
        payData.cashPayPrice = "";
        payData.bankPayPrice = "";

        weChatPayPrice = "";
        cashPayPrice = "";
        bankPayPrice = "";
        break
      }
      case 2: {
        payData.aliPayPrice = "";
        payData.cashPayPrice = "";
        payData.bankPayPrice = "";

        aliPayPrice = ""
        cashPayPrice = "";
        bankPayPrice = "";
        break
      }
      case 3: {
        payData.aliPayPrice = "";
        payData.weChatPayPrice = "";
        payData.bankPayPrice = "";

        aliPayPrice = ""
        weChatPayPrice = "";
        bankPayPrice = "";
        break
      }
      case 4: {
        payData.aliPayPrice = "";
        payData.weChatPayPrice = "";
        payData.cashPayPrice = "";

        aliPayPrice = ""
        weChatPayPrice = "";
        cashPayPrice = "";
        break
      }
      case 5: {
        break
      }
      default: {
        break
      }
    }

    let havePayMoney = new Decimal('0');
    let yhPrice = new Decimal('0');

    yhPrice = new Decimal(discountPrice ? discountPrice.toString() : '0');
    switch (event.target.value) {
      case 1: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0');
        break;
      }
      case 2: {
        havePayMoney = new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0');
        break;
      }
      case 3: {
        havePayMoney = new Decimal(cashPayPrice ? cashPayPrice.toString() : '0');
        break;
      }
      case 4: {
        havePayMoney = new Decimal(bankPayPrice ? bankPayPrice.toString() : '0');
        break;
      }
      case 5: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0').plus(new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0')).plus(new Decimal(cashPayPrice ? cashPayPrice.toString() : '0')).plus(new Decimal(bankPayPrice ? bankPayPrice.toString() : '0'));
        break;
      }
    }

    setAloneState({
      ...aloneState,
      ...payData,
      [event.target.name]: event.target.value,
      [event.target.name + '_isVisible']: false,
      balance: parseFloat((balanceMoney.minus(havePayMoney).minus(yhPrice)).toFixed(2))
    })
  }

  const inputChange = (event) => {
    console.log("2222222222", event.target.name);
    console.log("4444444444444", event.target.value);
    let payData = {};
    let { aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice } = state;
    if (event.target.name === "payStatus") {
      setIsDivVisible(prevIsDivVisible => !prevIsDivVisible);
      if (event.target.value === 2) {
        //赊欠
        payData.aliPayPrice = "";
        payData.weChatPayPrice = "";
        payData.cashPayPrice = "";
        payData.bankPayPrice = "";
        payData.discountPrice = "";
        let totalMoney = new Decimal('0'); // 订单总金额
        const keys = [...saleDataMap.keys()];
        for (let i = 0; i < keys.length; i++) {
          const moy = totalAmountData[keys[i]];
          totalMoney = totalMoney.plus(new Decimal(moy ? moy.toString() : '0'))
        }
        payData.balance = parseFloat(totalMoney.toFixed(2));
      }
    }

    if (event.target.name === "payType") {
      switch (event.target.value) {
        case 1: {
          payData.weChatPayPrice = "";
          payData.cashPayPrice = "";
          payData.bankPayPrice = "";

          weChatPayPrice = "";
          cashPayPrice = "";
          bankPayPrice = "";
          break
        }
        case 2: {
          payData.aliPayPrice = "";
          payData.cashPayPrice = "";
          payData.bankPayPrice = "";

          aliPayPrice = ""
          cashPayPrice = "";
          bankPayPrice = "";
          break
        }
        case 3: {
          payData.aliPayPrice = "";
          payData.weChatPayPrice = "";
          payData.bankPayPrice = "";

          aliPayPrice = ""
          weChatPayPrice = "";
          bankPayPrice = "";
          break
        }
        case 4: {
          payData.aliPayPrice = "";
          payData.weChatPayPrice = "";
          payData.cashPayPrice = "";

          aliPayPrice = ""
          weChatPayPrice = "";
          cashPayPrice = "";
          break
        }
        case 5: {
          break
        }
        default: {
          break
        }
      }
    }

    if (!event.target.value) {
      setState({
        ...state,
        [event.target.name]: '',
        [event.target.name + '_isVisible']: true,
      })
    } else {
      if (event.target.name === "payType" || (event.target.name === "payStatus" && event.target.value === 1)) {

        //计算剩余未支付金额
        let totalMoney = new Decimal('0'); // 订单总金额
        const keys = [...saleDataMap.keys()];
        for (let i = 0; i < keys.length; i++) {
          const moy = totalAmountData[keys[i]] ? totalAmountData[keys[i]] : new Decimal('0');
          debugger
          totalMoney = totalMoney.plus(new Decimal(moy.toString()))
        }
        let havePayMoney = new Decimal('0');
        let yhPrice = new Decimal('0');

        yhPrice = new Decimal(discountPrice ? discountPrice.toString() : '0');
        switch (event.target.value) {
          case 1: {
            havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0');
            break;
          }
          case 2: {
            havePayMoney = new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0');
            break;
          }
          case 3: {
            havePayMoney = new Decimal(cashPayPrice ? cashPayPrice.toString() : '0');
            break;
          }
          case 4: {
            havePayMoney = new Decimal(bankPayPrice ? bankPayPrice.toString() : '0');
            break;
          }
          case 5: {
            havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0').plus(new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0')).plus(new Decimal(cashPayPrice ? cashPayPrice.toString() : '0')).plus(new Decimal(bankPayPrice ? bankPayPrice.toString() : '0'));
            break;
          }
        }

        if (totalMoney.gt(new Decimal('0'))) {
          setState({
            ...state,
            ...payData,
            [event.target.name]: event.target.value,
            [event.target.name + '_isVisible']: false,
            balance: parseFloat((totalMoney.minus(havePayMoney).minus(yhPrice)).toFixed(2))
          })
        } else {
          setState({
            ...state,
            ...payData,
            [event.target.name]: event.target.value,
            [event.target.name + '_isVisible']: false
          })
        }
      } else if (event.target.name === "payStatus" && event.target.value === 2) {
        setState({
          ...state,
          ...payData,
          [event.target.name]: event.target.value,
          [event.target.name + '_isVisible']: false
        })
      } else {
        setState({
          ...state,
          [event.target.name]: event.target.value,
          [event.target.name + '_isVisible']: false
        })
      }
    }
  }

  const handleChange = (selectName, value) => {
    setState({
      ...state,
      [selectName]: value,
      [selectName + '_isVisible']: false
    })
  };

  const handleAlonePayChange = (name, value) => {
    let { payType, aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice } = aloneState;
    //计算剩余未支付金额
    let balanceMoney = new Decimal(balanceInfo); // 订单总金额
    let havePayMoney = new Decimal('0');
    let yhPrice = new Decimal('0');
    switch (name) {
      case "aliPayPrice": {
        aliPayPrice = value;
        break
      }
      case "weChatPayPrice": {
        weChatPayPrice = value;
        break
      }
      case "cashPayPrice": {
        cashPayPrice = value;
        break
      }
      case "bankPayPrice": {
        bankPayPrice = value;
        break
      }
      case "discountPrice": {
        discountPrice = value;
        break
      }
      default: {
        break
      }
    }
    yhPrice = new Decimal(discountPrice ? discountPrice.toString() : '0');
    switch (payType) {
      case 1: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0');
        break;
      }
      case 2: {
        havePayMoney = new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0');
        break;
      }
      case 3: {
        havePayMoney = new Decimal(cashPayPrice ? cashPayPrice.toString() : '0');
        break;
      }
      case 4: {
        havePayMoney = new Decimal(bankPayPrice ? bankPayPrice.toString() : '0');
        break;
      }
      case 5: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0').plus(new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0')).plus(new Decimal(cashPayPrice ? cashPayPrice.toString() : '0')).plus(new Decimal(bankPayPrice ? bankPayPrice.toString() : '0'));
        break;
      }
    }

    setAloneState({
      ...aloneState,
      [name]: value,
      balance: parseFloat((balanceMoney.minus(havePayMoney).minus(yhPrice)).toFixed(2))
    })
  }

  const handlePayChange = (name, value) => {
    let { payType, aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice } = state;
    //计算剩余未支付金额
    let totalMoney = new Decimal('0'); // 订单总金额
    const keys = [...saleDataMap.keys()];
    for (let i = 0; i < keys.length; i++) {
      const moy = totalAmountData[keys[i]];
      totalMoney = totalMoney.plus(new Decimal(moy.toString()))
    }
    let havePayMoney = new Decimal('0');
    let yhPrice = new Decimal('0');
    switch (name) {
      case "aliPayPrice": {
        aliPayPrice = value;
        break
      }
      case "weChatPayPrice": {
        weChatPayPrice = value;
        break
      }
      case "cashPayPrice": {
        cashPayPrice = value;
        break
      }
      case "bankPayPrice": {
        bankPayPrice = value;
        break
      }
      case "discountPrice": {
        discountPrice = value;
        break
      }
      default: {
        break
      }
    }
    yhPrice = new Decimal(discountPrice ? discountPrice.toString() : '0');
    switch (payType) {
      case 1: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0');
        break;
      }
      case 2: {
        havePayMoney = new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0');
        break;
      }
      case 3: {
        havePayMoney = new Decimal(cashPayPrice ? cashPayPrice.toString() : '0');
        break;
      }
      case 4: {
        havePayMoney = new Decimal(bankPayPrice ? bankPayPrice.toString() : '0');
        break;
      }
      case 5: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0').plus(new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0')).plus(new Decimal(cashPayPrice ? cashPayPrice.toString() : '0')).plus(new Decimal(bankPayPrice ? bankPayPrice.toString() : '0'));
        break;
      }
    }
    if (totalMoney.gt(new Decimal('0'))) {
      setState({
        ...state,
        balance: parseFloat((totalMoney.minus(havePayMoney).minus(yhPrice)).toFixed(2)),
        [name]: value
      })
    } else {
      setState({
        ...state,
        [name]: value
      })
    }
    console.log("66666", state);
  }

  //散售
  const handleBulkChange = (datakey, selectName, value) => {
    let currentData = saleDataMap.get(datakey);
    currentData[selectName] = value;
    const pId = currentData.packId;
    let pUnit = currentData.packUnit;//皮单位 1斤 2千克
    let pPrice = currentData.packPrice;
    let pWeight = currentData.packWeight;
    const peel = Number(currentData.peel);//刨皮 1是 2否
    const recycle = Number(currentData.recycle);//回收 1是 2否
    const num = currentData.num;
    const price = currentData.price;
    const grossWeight = currentData.totalWeight;
    if (selectName === "price") {
      setPriceSelData({ ...priceSelData, [datakey]: value });
    }
    if (selectName === "totalWeight") {
      if (value !== null) {
        if (num) {
          const dividend = new Decimal(value.toString()); // 被除数
          const divisor = new Decimal(num.toString()); // 除数
          const result = dividend.div(divisor); // 执行除法
          let averageWeight = parseFloat(result.toFixed(2));
          setAverageWeightData({ ...averageWeightData, [datakey]: averageWeight })
          currentData = { ...currentData, averageWeight };
        }
        else {
          setAverageWeightData({ ...averageWeightData, [datakey]: value })
          currentData = { ...currentData, 'averageWeight': value };
        }
      } else {
        setAverageWeightData({ ...averageWeightData, [datakey]: "" })
        currentData = { ...currentData, 'averageWeight': "" };
      }
      setTotalWeightData({ ...totalWeightData, [datakey]: value });
    }

    if (selectName === "num") {
      if (value !== null && value !== 0) {
        if (grossWeight) {
          const dividend = new Decimal(grossWeight.toString()); // 被除数
          const divisor = new Decimal(value.toString()); // 除数
          const result = dividend.div(divisor); // 执行除法
          let averageWeight = parseFloat(result.toFixed(2));
          setAverageWeightData({ ...averageWeightData, [datakey]: averageWeight })
          currentData = { ...currentData, averageWeight };
        } else {
          setAverageWeightData({ ...averageWeightData, [datakey]: "" })
          currentData = { ...currentData, 'averageWeight': "" };
        }
      } else {
        setAverageWeightData({ ...averageWeightData, [datakey]: "" })
        currentData = { ...currentData, 'averageWeight': "" };
      }
      setNumSelData({ ...numSelData, [datakey]: value });
    }
    if (selectName === "peel") {
      setPeelData({ ...peelData, [datakey]: value })
    }
    if (selectName === "recycle") {
      setRecycleData({ ...recycleData, [datakey]: value })
    }
    if (selectName === "goodsId") {
      setGoodsData({ ...goodsData, [datakey]: value })
    }
    if (selectName === "packId") {
      //获取包装的价格和重量
      const packData = packInfo.get(value);
      const punit = packData.packUnit;
      let pWt = packData.packWeight;
      if (punit === 2) {
        //千克
        pWt = pWt * 2;
      }
      const weightD = { ...weightData, [datakey]: pWt }
      setWeightData(weightD);
      const priceD = { ...priceData, [datakey]: packData.packPrice }
      setPriceData(priceD);
      console.log("88888", weightD);
      console.log("55555", packInfo.get(value));
      currentData = { ...currentData, ...packData };
      pUnit = packData.packUnit;//皮单位 1斤 2千克
      pPrice = packData.packPrice;
      pWeight = packData.packWeight;
      setPackSelData({ ...packSelData, [datakey]: value });
    }

    let suttle = new Decimal('0');//净重
    if (pId && grossWeight && num && price) {
      let tMoney = new Decimal('0');
      const gWeight = new Decimal(grossWeight.toString());
      const dNum = new Decimal(num.toString());
      //毛重
      if (peel == 1) {
        const weight = new Decimal(pWeight.toString());
        const unit = new Decimal(pUnit.toString());
        const tWeight = weight.times(unit).times(dNum);
        suttle = gWeight.minus(tWeight);
      } else {
        suttle = gWeight;
      }

      if (suttle.lt(new Decimal('0'))) {
        //毛重小于皮重
        openNotificationWithIcon('error', '消息提示', "货品毛重不能小于皮重之和");
        setTotalAmountData({ ...totalAmountData, [datakey]: "" })
        currentData = { ...currentData, 'totalMoney': "" };
        setBalanceData(datakey, new Decimal('0'));
      } else {
        if (recycle == 2) {
          //不回收 总金额加上包装的钱
          tMoney = suttle.times(new Decimal(price.toString())).plus(new Decimal(pPrice.toString()).times(dNum))
        } else {
          tMoney = suttle.times(new Decimal(price.toString()))
        }
        setTotalAmountData({ ...totalAmountData, [datakey]: parseFloat(tMoney.toFixed(2)) })
        currentData = { ...currentData, 'totalMoney': parseFloat(tMoney.toFixed(2)) };
        //jisuanaaaaa
        setBalanceData(datakey, tMoney);
      }
    } else {
      setTotalAmountData({ ...totalAmountData, [datakey]: "" })
      currentData = { ...currentData, 'totalMoney': "" };
      setBalanceData(datakey, new Decimal('0'));
    }
    saleDataMap.set(datakey, currentData);
    console.log("66666444444444444444", currentData);
    // setSaleDataMap(saleDataMap);
    console.log("666666666666666666", saleDataMap);
  };

  //整售
  const handleWholeSaleChange = (datakey, selectName, value) => {

    let currentData = saleDataMap.get(datakey);
    currentData[selectName] = value;
    if (selectName === "num") {
      setNumSelData({ ...numSelData, [datakey]: value })
    }

    if (selectName === "price") {
      setPriceSelData({ ...priceSelData, [datakey]: value })
    }
    if (selectName === "recycle") {
      setRecycleData({ ...recycleData, [datakey]: value })
    }
    if (selectName === "goodsId") {
      setGoodsData({ ...goodsData, [datakey]: value })
    }

    if (selectName === "packId") {
      setPackSelData({ ...packSelData, [datakey]: value });
    }
    const num = currentData.num;
    const price = currentData.price;
    if (num && price) {
      let tMoney = new Decimal('0');
      const dNum = new Decimal(num.toString());
      tMoney = new Decimal(price.toString()).times(dNum)
      setTotalAmountData({ ...totalAmountData, [datakey]: parseFloat(tMoney.toFixed(2)) })
      currentData = { ...currentData, 'totalMoney': parseFloat(tMoney.toFixed(2)) };
      //jisuanaaaaa
      setBalanceData(datakey, tMoney);
    } else {
      setTotalAmountData({ ...totalAmountData, [datakey]: "" })
      currentData = { ...currentData, 'totalMoney': "" };

      setBalanceData(datakey, new Decimal('0'));
    }
    saleDataMap.set(datakey, currentData);
    console.log("66666444444444444444", currentData);
    // setSaleDataMap(saleDataMap);
    console.log("666666666666666666", saleDataMap);
  };


  //计算剩余未支付金额
  function setBalanceData(datakey, tMoney) {
    let { payType, aliPayPrice, weChatPayPrice, cashPayPrice, bankPayPrice, discountPrice } = state;
    let totalMoney = new Decimal('0'); // 订单总金额
    const keys = [...saleDataMap.keys()];
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === datakey) {
        const moy = parseFloat(tMoney.toFixed(2));
        totalMoney = totalMoney.plus(new Decimal(moy ? moy.toString() : '0'))
      } else {
        const moy = totalAmountData[keys[i]];
        totalMoney = totalMoney.plus(new Decimal(moy ? moy.toString() : '0'))
      }
    }
    let havePayMoney = new Decimal('0');
    let yhPrice = new Decimal('0');

    yhPrice = new Decimal(discountPrice ? discountPrice.toString() : '0');
    switch (payType) {
      case 1: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0');
        break;
      }
      case 2: {
        havePayMoney = new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0');
        break;
      }
      case 3: {
        havePayMoney = new Decimal(cashPayPrice ? cashPayPrice.toString() : '0');
        break;
      }
      case 4: {
        havePayMoney = new Decimal(bankPayPrice ? bankPayPrice.toString() : '0');
        break;
      }
      case 5: {
        havePayMoney = new Decimal(aliPayPrice ? aliPayPrice.toString() : '0').plus(new Decimal(weChatPayPrice ? weChatPayPrice.toString() : '0')).plus(new Decimal(cashPayPrice ? cashPayPrice.toString() : '0')).plus(new Decimal(bankPayPrice ? bankPayPrice.toString() : '0'));
        break;
      }
    }

    if (totalMoney.gt(new Decimal('0'))) {
      setState({
        ...state,
        balance: parseFloat((totalMoney.minus(havePayMoney).minus(yhPrice)).toFixed(2))
      })
    } else {
      setState({
        ...state,
        balance: ''
      })
    }
  }




  //商品分类
  const handleCategory = (datakey, selectName, value) => {
    //根据分类查找对应可用商品
    const data = {
      'category': value,
      'status': 1
    }
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/goods/list',
      data
    ).then(
      response => {
        if (response.data.code === "200") {
          const cData = response.data.data;
          let cDataArr = [];
          for (let i = 0; i < cData.length; i++) {
            cDataArr.push(
              { value: cData[i].id, label: cData[i].goodsName }
            )
          }
          const list = { ...goodsList, [datakey]: cDataArr }
          setGoodsList(list);
          setGoodsCategoryData({ ...goodsCategoryData, [datakey]: value });
          console.log("AAA2222", goodsCategoryData);
          setGoodsData({ ...goodsData, [datakey]: undefined })
        } else {
          openNotificationWithIcon('error', '消息提示', '货品数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  };


  //Bulk sales
  const addBulkSaleCard = () => {
    let currentTime = Date.now();
    const cardTitle = "订单" + currentTime;
    setBulkSale([...bulkSale, { key: currentTime, title: cardTitle }]);
    saleDataMap.set(currentTime, { orderNum: currentTime, peel: 1, recycle: 1, type: 1 });
    console.log("1111111111111", saleDataMap);
    // setCard1Count(card1Count + 1)
  };

  //删除散售
  const removeBulkSaleCard = (key) => {
    saleDataMap.delete(key);
    console.log("666666666666666666", saleDataMap);
    setBulkSale(bulkSale.filter(card => card.key !== key));
    setBalanceData(key, new Decimal('0'));
  };

  //Whole Sale
  const addWholeSaleCard = () => {
    let currentTime = Date.now();
    const cardTitle = "订单" + currentTime;
    setWholeSale([...wholeSale, { key: currentTime, title: cardTitle }]);
    saleDataMap.set(currentTime, { orderNum: currentTime, recycle: 1, type: 2 });
    console.log("2222222222222222222222222", saleDataMap);
  };
  //删除整售
  const removeWholeSaleCard = (key) => {
    saleDataMap.delete(key);
    setWholeSale(wholeSale.filter(card => card.key !== key));

    setBalanceData(key, new Decimal('0'));
  };

  const columns = [
    {
      title: '客户名称',
      dataIndex: 'customerName',
      key: 'customerName',
      fixed: 'left',
      align: 'center',
      width: 150,
      responsive: ['lg'],
    },
    {
      title: '订单类别',
      dataIndex: 'mode',
      key: 'mode',
      fixed: 'left',
      align: 'center',
      width: 150,
      responsive: ['lg'],
      render: (_, record) => (
        <span>{record.mode === 1 ? "销售" : "采购"}</span>
      )
    },
    {
      title: '支付状态',
      dataIndex: 'payStatus',
      key: 'payStatus',
      align: 'center',
      width: 150,
      responsive: ['lg'],
      render: (_, record) => {
        let name = "";
        switch (record.payStatus) {
          case 1:
            name = "全支付";
            break;
          case 2:
            name = "赊欠";
            break;
          case 3:
            name = "部分支付";
            break;
        }
        return <span>{name}</span>;
      }
    },
    {
      title: '全部金额',
      dataIndex: 'totalMoney',
      key: 'totalMoney',
      fixed: 'left',
      align: 'center',
      width: 150,
      responsive: ['lg']
    },
    {
      title: '剩余未支付',
      dataIndex: 'balance',
      key: 'balance',
      fixed: 'left',
      align: 'center',
      width: 150,
      responsive: ['lg']
    },
    {
      title: '开单时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center',
      sorter: (a, b) => moment(a.createTime).diff(moment(b.createTime)),
      defaultSortOrder: 'ascend',
      width: 200,
      responsive: ['lg'],
      render: (val) => moment(val).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: '订单状态',
      dataIndex: 'valid',
      key: 'valid',
      align: 'center',
      width: 150,
      responsive: ['lg'],
      render: (_, record) => (
        <span style={record.valid === 2 ? { color: '#FF0000' } : { color: '#68cf4f' }}>{record.valid === 1 ? "有效" : "废单"}</span>
      )
    },
    {
      title: '操作',
      key: 'operation',
      align: 'center',
      // responsive: ['lg'],
      render: (_, record) => (
        <div>
          <a onClick={() => modifyShowModal(record.id)} style={{ marginRight: '20px' }}>编辑</a>
          <a onClick={() => paymentMoney(record.id, record.balance)} style={record.valid === 2 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : record.payStatus === 1 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : record.mode === 1 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : { marginRight: '20px', color: '#FF0000' }} >支付</a>
          <a onClick={() => receiveMoney(record.id, record.balance)} style={record.valid === 2 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : record.payStatus === 1 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : record.mode === 2 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : { marginRight: '20px', color: '#68cf4f' }} >收款</a>
          <a onClick={() => handleEffectAndCancel(record.id, 1)} style={record.valid === 1 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : { marginRight: '20px', color: '#68cf4f' }} >生效</a>
          <a onClick={() => handleEffectAndCancel(record.id, 2)} style={record.valid === 2 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : { marginRight: '20px', color: '#FF0000' }}>废弃</a>
          <a onClick={() => optionHistory(record.id)}>操作历史</a>
        </div>
      )
    },
  ];

  return (
    <React.Fragment>
      {contextHolder}
      <div className="item-location">
        当前所在位置 : 订单信息
      </div>

      <Serach fields={searchFields} initState={initialFields} onSearch={handleSearch} />

      <div className="data-div">
        <div className="bt_group">
          <Button onClick={showModal} className="bt_group_add"><PlusOutlined />开单</Button>
        </div>
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            rowSelection={rowSelection}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage: 'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>


      <Modal
        open={openMoney}
        title={modalMoneyTitle}
        onOk={handleOkMoney}
        onCancel={handleCancelMoney}
        width={1500}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div style={{ marginTop: '20px' }}>
          <div>
            <span style={{ fontSize: '15px' }}>{balanceTitle}</span>
            <span style={{ fontSize: '20px', color: 'red' }}>{balanceInfo}</span>
          </div>
          <div>
            <div style={{ marginTop: '20px' }}>
              <Card title="支付信息" style={{ marginBottom: 10 }}>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '45%' }}>
                      <div style={{ width: '15%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>付款方式</span>
                      </div>
                      <div style={{ width: '85%', paddingRight: '10px' }}>
                        <Radio.Group name="payType" value={aloneState.payType} onChange={payTypeChange}
                          options={[
                            { value: 1, label: '支付宝' },
                            { value: 2, label: '微信' },
                            { value: 3, label: '现金' },
                            { value: 4, label: '银行转账' },
                            { value: 5, label: '组合支付' }
                          ]}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%', marginTop: '10px' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }} >
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>支付宝金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} disabled={aloneState.payType == 1 || aloneState.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="aliPayPrice" value={aloneState.aliPayPrice} onChange={(value) => handleAlonePayChange("aliPayPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>微信金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} disabled={aloneState.payType == 2 || aloneState.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="weChatPayPrice" value={aloneState.weChatPayPrice} onChange={(value) => handleAlonePayChange("weChatPayPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>现金金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} disabled={aloneState.payType == 3 || aloneState.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="cashPayPrice" value={aloneState.cashPayPrice} onChange={(value) => handleAlonePayChange("cashPayPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '25%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>银行转账金额</span>
                      </div>
                      <InputNumber style={{ width: '75%' }} disabled={aloneState.payType == 4 || aloneState.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="bankPayPrice" value={aloneState.bankPayPrice} onChange={(value) => handleAlonePayChange("bankPayPrice", value)} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>优惠金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="discountPrice" value={aloneState.discountPrice} onChange={(value) => handleAlonePayChange("discountPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '50%' }}>
                      <div style={{ width: '50%', paddingRight: '10px', textAlign: 'left' }}>
                        <span style={{ marginRight: '15px' }}>{balanceTitle}</span>
                        <span style={{ borderBottom: '1px solid #9C9FA3' }}>{aloneState.balance}</span>
                        <span>元</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </Modal>


      <Modal
        open={open}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1500}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div style={{ marginTop: '20px' }}>
          <div className="order_modal_field_style">
            <div className="order_modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>客户名称:</span>
            </div>
            <div style={{ width: '95%' }}>
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="请选择客户"
                onChange={(value) => handleChange("customerId", value)}
                value={state.customerId}
                options={customerList}
              />
            </div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '94%' }}><span className={state.customerId_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请选择客户名称</span></div>
          </div>

          <div className="order_modal_field_style_2">
            <div className="order_modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>订单类别:</span>
            </div>
            <div style={{ width: '95%' }}>
              <Radio.Group name="mode" value={state.mode} onChange={inputChange}
                options={[
                  { value: 1, label: '销售' },
                  { value: 2, label: '采购' }
                ]}
              />
            </div>
          </div>
          <div className="order_modal_field_style_2">
            <div className="order_modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>支付状态:</span>
            </div>
            <div style={{ width: '95%' }}>
              <Radio.Group name="payStatus" value={state.payStatus} onChange={inputChange}
                options={[
                  { value: 1, label: '有支付' },
                  { value: 2, label: '赊欠' },
                ]}
              />
            </div>
          </div>
          <div style={{ borderRadius: '5px' }}>
            <Card title="散装" extra={<a onClick={addBulkSaleCard}><PlusOutlined /></a>}>
              {bulkSale.map(card => (
                <Card key={card.key} title={card.title} style={{ marginBottom: 10 }} extra={<a onClick={() => removeBulkSaleCard(card.key)}><MinusOutlined /></a>}>
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '35%' }}>
                        <div style={{ width: '10%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>货品</span>
                        </div>
                        <div style={{ width: '45%', paddingRight: '10px' }}>
                          <Select
                            style={{ width: '100%' }}
                            value={goodsCategoryData[card.key]}
                            placeholder="请选择货品分类"
                            onChange={(value) => handleCategory(card.key, "category", value)}
                            options={goodsCategory}
                          />
                        </div>

                        <div style={{ width: '45%', paddingRight: '10px' }}>
                          <Select
                            style={{ width: '100%' }}
                            value={goodsData[card.key]}
                            placeholder="请选择货品名称"
                            onChange={(value) => handleBulkChange(card.key, "goodsId", value)}
                            options={goodsList[card.key]}
                          />
                        </div>

                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '40%' }}>
                        <div style={{ width: '10%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>包装</span>
                        </div>
                        <div style={{ width: '40%', paddingRight: '10px' }}>
                          <Select
                            style={{ width: '100%' }}
                            value={packSelData[card.key]}
                            placeholder="请选择分类"
                            onChange={(value) => handleBulkChange(card.key, "packId", value)}
                            options={packList}
                          />
                        </div>
                        <div style={{ width: '20%', paddingRight: '10px' }}>
                          <span style={{ marginRight: '15px' }}>皮价格</span>
                          <span style={{ borderBottom: '1px solid #9C9FA3' }}>{priceData[card.key]}</span>
                          <span>元</span>
                        </div>
                        <div style={{ width: '20%', paddingRight: '10px' }}>
                          <span style={{ marginRight: '15px' }}>皮重量</span>
                          <span style={{ borderBottom: '1px solid #9C9FA3' }}>{weightData[card.key]}</span>
                          <span>斤</span>
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                        <div style={{ width: '50%', paddingRight: '10px' }}>
                          <span style={{ marginRight: '10px' }}>刨皮</span>
                          <Radio.Group name="peel" value={peelData[card.key]} onChange={(event) => handleBulkChange(card.key, "peel", event.target.value)} defaultValue={1}
                            options={[
                              { value: 1, label: '是' },
                              { value: 2, label: '否' }
                            ]}
                          />
                        </div>
                        <div style={{ width: '50%', paddingRight: '10px' }}>
                          <span style={{ marginRight: '10px' }}>回收</span>
                          <Radio.Group name="recycle" value={recycleData[card.key]} onChange={(event) => handleBulkChange(card.key, "recycle", event.target.value)} defaultValue={1}
                            options={[
                              { value: 1, label: '是' },
                              { value: 2, label: '否' }
                            ]}
                          />
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px' }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '35%' }}>
                        <div style={{ width: '10%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>数量</span>
                        </div>
                        <InputNumber style={{ width: '30%' }} min={0} max={100000000} formatter={value => `${value}`.replace(/\D/g, '')} parser={value => value.replace(/\D/g, '')} value={numSelData[card.key]} changeOnWheel onChange={(value) => handleBulkChange(card.key, "num", value)} />
                        <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>单价(元/斤)</span>
                        </div>
                        <InputNumber style={{ width: '40%' }} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} value={priceSelData[card.key]} changeOnWheel onChange={(value) => handleBulkChange(card.key, "price", value)} />
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '35%' }}>
                        <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>毛重(斤)</span>
                        </div>
                        <div style={{ width: '40%', paddingRight: '10px' }}>
                          <InputNumber style={{ width: '100%' }} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} value={totalWeightData[card.key]} changeOnWheel onChange={(value) => handleBulkChange(card.key, "totalWeight", value)} />
                        </div>
                        <div style={{ width: '30%', paddingRight: '10px', textAlign: 'left' }}>
                          <span style={{ marginRight: '15px' }}>均重</span>
                          <span style={{ borderBottom: '1px solid #9C9FA3' }}>{averageWeightData[card.key]}</span>
                          <span>斤</span>
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                        <span style={{ marginRight: '15px' }}>总金额</span>
                        <span style={{ borderBottom: '1px solid #9C9FA3' }}>{totalAmountData[card.key]}</span>
                        <span>元</span>
                      </div>
                    </div>
                  </div>

                </Card>
              ))}
            </Card>
          </div>

          <div style={{ marginTop: '20px' }}>
            <Card title="整装" extra={<a onClick={addWholeSaleCard}><PlusOutlined /></a>}>
              {wholeSale.map(card => (
                <Card key={card.key} title={card.title} style={{ marginBottom: 10 }} extra={<a onClick={() => removeWholeSaleCard(card.key)}><MinusOutlined /></a>}>
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '35%' }}>
                        <div style={{ width: '10%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>货品</span>
                        </div>
                        <div style={{ width: '45%', paddingRight: '10px' }}>
                          <Select
                            style={{ width: '100%' }}
                            value={goodsCategoryData[card.key]}
                            placeholder="请选择货品分类"
                            onChange={(value) => handleCategory(card.key, "category", value)}
                            options={goodsCategory}
                          />
                        </div>

                        <div style={{ width: '45%', paddingRight: '10px' }}>
                          <Select
                            style={{ width: '100%' }}
                            value={goodsData[card.key]}
                            placeholder="请选择货品名称"
                            onChange={(value) => handleWholeSaleChange(card.key, "goodsId", value)}
                            options={goodsList[card.key]}
                          />
                        </div>

                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                        <div style={{ width: '10%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>包装</span>
                        </div>
                        <div style={{ width: '80%', paddingRight: '10px' }}>
                          <Select
                            style={{ width: '100%' }}
                            value={packSelData[card.key]}
                            placeholder="请选择分类"
                            onChange={(value) => handleWholeSaleChange(card.key, "packId", value)}
                            options={packList}
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '30%' }}>
                        <div style={{ width: '40%', paddingRight: '10px' }}>
                          <span style={{ marginRight: '10px' }}>回收</span>
                          <Radio.Group name="recycle" value={recycleData[card.key]} onChange={(event) => handleWholeSaleChange(card.key, "recycle", event.target.value)} defaultValue={1}
                            options={[
                              { value: 1, label: '是' },
                              { value: 2, label: '否' }
                            ]}
                          />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '60%' }}>
                          <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                            <span>数量</span>
                          </div>
                          <InputNumber style={{ width: '60%' }} min={0} max={100000000} formatter={value => `${value}`.replace(/\D/g, '')} parser={value => value.replace(/\D/g, '')} value={numSelData[card.key]} changeOnWheel onChange={(value) => handleWholeSaleChange(card.key, "num", value)} />
                        </div>

                      </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px' }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '35%' }}>
                        <div style={{ width: '10%', paddingRight: '10px', textAlign: 'right' }}>
                          <span>单价</span>
                        </div>
                        <InputNumber style={{ width: '40%' }} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} value={priceSelData[card.key]} changeOnWheel onChange={(value) => handleWholeSaleChange(card.key, "price", value)} />
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%', paddingLeft: '15px' }}>
                          <span style={{ marginRight: '15px' }}>总金额</span>
                          <span style={{ borderBottom: '1px solid #9C9FA3' }}>{totalAmountData[card.key]}</span>
                          <span>元</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </Card>
          </div>

          {isDivVisible &&
            <div style={{ marginTop: '20px' }}>
              <Card title="支付信息" style={{ marginBottom: 10 }}>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '45%' }}>
                      <div style={{ width: '15%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>支付方式</span>
                      </div>
                      <div style={{ width: '85%', paddingRight: '10px' }}>
                        <Radio.Group name="payType" value={state.payType} onChange={inputChange}
                          options={[
                            { value: 1, label: '支付宝' },
                            { value: 2, label: '微信' },
                            { value: 3, label: '现金' },
                            { value: 4, label: '银行转账' },
                            { value: 5, label: '组合支付' }
                          ]}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%', marginTop: '10px' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }} >
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>支付宝金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} disabled={state.payType == 1 || state.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="aliPayPrice" value={state.aliPayPrice} onChange={(value) => handlePayChange("aliPayPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>微信金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} disabled={state.payType == 2 || state.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="weChatPayPrice" value={state.weChatPayPrice} onChange={(value) => handlePayChange("weChatPayPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>现金金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} disabled={state.payType == 3 || state.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="cashPayPrice" value={state.cashPayPrice} onChange={(value) => handlePayChange("cashPayPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '25%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>银行转账金额</span>
                      </div>
                      <InputNumber style={{ width: '75%' }} disabled={state.payType == 4 || state.payType == 5 ? false : true} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="bankPayPrice" value={state.bankPayPrice} onChange={(value) => handlePayChange("bankPayPrice", value)} />
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '25%' }}>
                      <div style={{ width: '20%', paddingRight: '10px', textAlign: 'right' }}>
                        <span>优惠金额</span>
                      </div>
                      <InputNumber style={{ width: '70%' }} min={0} max={100000000} formatter={limitDecimalPoint} parser={normalizeDecimalPoint} changeOnWheel name="discountPrice" value={state.discountPrice} onChange={(value) => handlePayChange("discountPrice", value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '50%' }}>
                      <div style={{ width: '50%', paddingRight: '10px', textAlign: 'left' }}>
                        <span style={{ marginRight: '15px' }}>剩余未支付金额</span>
                        <span style={{ borderBottom: '1px solid #9C9FA3' }}>{state.balance}</span>
                        <span>元</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          }
        </div>
      </Modal>
    </React.Fragment>

  )
}
